import PermissionService from '@services/permission.service';
import { coreTranslations } from 'translations';
const schedulesMenuItem = _rootMenu;

const permissionsService = new PermissionService();

function _rootMenu() {
    return {
        i18n: coreTranslations.ng_core_schedules,
        linkTitle: 'Schedules',
        routeTo: '/schedules',
        icon: 'onsolve-schedules-icon',
        isRenderable: true,
        accessConfiguration: permissions => permissions.canViewSchedule() && !permissionsService.permissions.usesNextGenSendingEngine()
    };
}

export default schedulesMenuItem;
